import React from "react";
import { PowerSkillLastTestResponse } from "../../typings/powerskill";
import Button from "../UI/Button";
import { Card, CardContent, CardHeader } from "../UI/Card";
import { Eye, TrendingUp } from "lucide-react";
import PowerSkillPdfDownload from "./PowerSkillPdfDownload";

interface PowerSkillLastTestProps {
  lastTest: PowerSkillLastTestResponse;
  onViewDetail: () => void;
}

const PowerSkillLastTest: React.FC<PowerSkillLastTestProps> = ({
  lastTest,
  onViewDetail,
}) => {
  const test = lastTest.data.test;

  return (
    <Card className="mt-4">
      <CardHeader className="border-b border-indigo-50 bg-indigo-50/30">
        <div className="flex justify-between items-center">
          <h5 className="text-lg font-bold text-indigo-900">Hasil Terakhir</h5>
          <span className="text-xs text-indigo-600 bg-indigo-100 px-2 py-1 rounded-full font-medium">
            {new Date(lastTest.data.test.created_at).toLocaleDateString(
              "id-ID",
              {
                day: "numeric",
                month: "long",
                year: "numeric",
              }
            )}
          </span>
        </div>
      </CardHeader>
      <CardContent className="p-6">
        <div className="flex flex-col items-center mb-8">
          <div className="bg-orange-100 p-4 rounded-full mb-3">
            <TrendingUp className="w-8 h-8 text-foreground" />
          </div>
          <div className="text-2xl font-black text-indigo-900 text-center mb-1">
            {test.result_category}
          </div>
          <div className="text-xs text-gray-400 font-bold uppercase tracking-widest">
            Kategori PowerSkills
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <Button
            primary
            className="w-full gradient-primary text-white py-4 font-bold flex items-center justify-center gap-2 border-none"
            onClick={onViewDetail}
          >
            <Eye className="w-5 h-5" /> Lihat Analisis Lengkap
          </Button>
          <PowerSkillPdfDownload testId={test.id} />
        </div>
      </CardContent>
    </Card>
  );
};

export default PowerSkillLastTest;
